// The one canonical reactjs-popup contentStyle for artist-picker modals —
// ArtistPickerField, the V3 offer change/add-artist popups, and the Event Page
// lineup card. Kept in its own dependency-free module so importing the style
// doesn't pull the shared axios client into a consumer's import chain.
export const ARTIST_PICKER_MODAL_STYLE = {
  border: "none",
  borderRadius: "12px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "480px",
  maxWidth: "calc(100vw - 16px)",
  padding: "0",
};
